import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="lg:w-1/2 relative h-[350px] md:h-[500px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20scandal%20concept%20with%20fractured%20screen%20effect%2C%20dark%20and%20warm%20atmospheric%20lighting%2C%20news%20breaking%20story%20aesthetic%2C%20amber%20glow%20with%20deep%20shadows%2C%20editorial%20photography%2C%20abstract%20dramatic%20mood&width=960&height=700&seq=cta-left-bg&orientation=landscape"
          alt="网红翻车现场"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        <div className="absolute top-0 left-0 p-6 md:p-8">
          <span className="text-xs text-background-50/60 font-medium tracking-widest uppercase">独家追踪</span>
        </div>
        <div className="absolute bottom-0 left-0 p-6 md:p-8">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-background-50 leading-none">
            网红翻车
            <br />
            现场直击
            <br />
            实时追踪
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 md:px-12 py-12 md:py-16 bg-background-50">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight text-center">
          不错过
          <br />
          任何一个大瓜
        </h2>
        <p className="mt-5 text-sm md:text-base text-foreground-500 text-center max-w-sm leading-relaxed">
          吃瓜官网每日更新全网最新爆料，从娱乐圈到网红圈，从黑料实锤到翻车现场，你想看的瓜都在这里。订阅我们，第一时间获取独家猛料。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link
            to="/category/wanghong"
            className="px-7 py-3 bg-secondary-950 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-secondary-800 transition-all cursor-pointer whitespace-nowrap text-center group inline-flex items-center justify-center gap-2"
          >
            看网红翻车
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to="/category/black-material"
            className="px-7 py-3 border-2 border-foreground-200 text-foreground-800 font-label text-sm font-semibold rounded-full hover:border-primary-400 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap text-center"
          >
            看黑料实锤
          </Link>
        </div>
      </div>
    </section>
  );
}